import { $, $$ } from '../helpers/selectors';
import IScroll from '../libs/iscroll';

const SELECTOR = '.internal-hub-nav';

class InternalHubMenu {
  constructor() {
    if (! $(SELECTOR)) {
      return false;
    }

    if ($('.hero__no-image')) {
      $('.hero__no-image').classList.add('no-negative-margin');
    }

    const internalHubMenu = $('.internal-hub-nav__nav');
    // eslint-disable-next-line
    const $j = jQuery;
    let lastScroll = 0;
    let scrollDelay = null;
    let totalOuterWidth = 0;
    const adminOffset = $('.admin-bar') ? 34 : 0;

    $$('.internal-hub-nav__nav li').forEach(listItem => {
      totalOuterWidth = totalOuterWidth + listItem.offsetWidth;
    });

    internalHubMenu.style.width = totalOuterWidth + 'px';

    const internalHubMenuScroll = new IScroll('.internal-hub-nav__nav-wrap', {
      scrollX: true,
      scrollY: false,

      scrollbars: false,
      bounce: true,
      preventDefault: true,
    });

    internalHubMenuScroll.on('scrollEnd', function() {
      setGradient(this.x, this.maxScrollX);
      if (this.x === this.maxScrollX) {
        $('.js-internal-hub__scroll-right').classList.add('disabled');
        $('.js-internal-hub__scroll-right').setAttribute('disabled', true);

        $('.js-internal-hub__scroll-left').classList.remove('disabled');
        $('.js-internal-hub__scroll-left').removeAttribute('disabled');
      } else if (this.x === 0) {
        $('.js-internal-hub__scroll-left').classList.add('disabled');
        $('.js-internal-hub__scroll-left').setAttribute('disabled', true);

        $('.js-internal-hub__scroll-right').classList.remove('disabled');
        $('.js-internal-hub__scroll-right').removeAttribute('disabled');
      } else {
        $('.js-internal-hub__scroll-right').classList.remove('disabled');
        $('.js-internal-hub__scroll-left').classList.remove('disabled');

        $('.js-internal-hub__scroll-right').removeAttribute('disabled');
        $('.js-internal-hub__scroll-left').removeAttribute('disabled');
      }
    });

    function isInViewport(el) {
      const rect = el.getBoundingClientRect();

      return (rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth));
    }

    function setGradient(x, maxScrollX) {
      if (x >= -5) {
        $j(internalHubMenu).closest('.internal-hub-nav__nav-desktop').removeClass('scroll-end--right');
        $j(internalHubMenu).closest('.internal-hub-nav__nav-desktop').addClass('scroll-end--left');
      } else if (x < 0 && x >= (maxScrollX + 1)) {
        $j(internalHubMenu).closest('.internal-hub-nav__nav-desktop').removeClass('scroll-end--left scroll-end--right');
      } else if (x <= maxScrollX) {
        $j(internalHubMenu).closest('.internal-hub-nav__nav-desktop').addClass('scroll-end--right');
        $j(internalHubMenu).closest('.internal-hub-nav__nav-desktop').removeClass('scroll-end--left');
      }

      if (maxScrollX === 0) {
        $('.internal-hub-nav__nav-desktop').classList.add('no-scrolling');
        $j(internalHubMenu).closest('.internal-hub-nav__nav-desktop').addClass('scroll-end--right', 'scroll-end--left');
      }
    }

    $$('.internal-hub-nav__nav a').forEach(navLink => {
      $j(navLink).click(function(event) {
        // Figure out element to scroll to
        let target = $j(this.hash);
        target = target.length ? target : $j('[name=' + this.hash.slice(1) + ']');

        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          window.scrollTo({
            top: target.offset().top - 80,
          });
          setTimeout(() => {
            scrollGradientCheck();
          }, 200);
        }
      });
    });

    $('.js-internal-hub__scroll-left').addEventListener('click', () => {
      internalHubMenuScroll.scrollBy(80, 0, 200, IScroll.utils.ease.quadratic);
    });

    $('.js-internal-hub__scroll-right').addEventListener('click', () => {
      internalHubMenuScroll.scrollBy(-80, 0, 200, IScroll.utils.ease.quadratic);
    });

    function handleOnScroll() {
      const currentScrollPos = window.pageYOffset;
      const internalHubMenuWrap = $(SELECTOR);
      const internalHubMenuWrapHeight = $('.internal-hub-height');
      const currentActiveLink = document.querySelector('.internal-hub-nav__nav li.link-active');

      if (currentScrollPos >= $j(internalHubMenuWrapHeight).offset().top - adminOffset) {
        internalHubMenuWrap.classList.add('is-sticky');
        internalHubMenuWrapHeight.classList.add('active');
        internalHubMenuWrap.classList.remove('menu-is-visible');
      } else {
        if (internalHubMenuWrap.classList.contains('is-sticky')) {
          internalHubMenuScroll.scrollToElement(internalHubMenu.querySelector('li:first-child'), 200, -30, 0, IScroll.utils.ease.quadratic);
          $('.js-internal-hub__scroll-right').classList.remove('disabled');
          $('.js-internal-hub__scroll-left').removeAttribute('disabled');
        }

        if (currentActiveLink) {
          currentActiveLink.classList.remove('link-active');
        }

        internalHubMenuWrap.classList.remove('is-sticky');
        internalHubMenuWrapHeight.classList.remove('active');
      }

      if (currentScrollPos < lastScroll) {
        internalHubMenuWrap.classList.add('menu-is-visible');
        if (scrollDelay) {
          clearTimeout(scrollDelay); //cancel the previous timer.
          scrollDelay = null;
        }
        scrollDelay = setTimeout(() => {
          if (window.pageYOffset !== 0) {
            internalHubMenuWrap.classList.remove('menu-is-visible');
          }
        }, 4000);
      }

      scrollGradientCheck();

      lastScroll = currentScrollPos;
    }

    function handleOnScrollMobile() {
      const currentScrollPos = window.pageYOffset;
      const internalHubMenuWrap = $(SELECTOR);
      const internalHubMenuWrapHeight = $('.internal-hub-height');

      if (currentScrollPos >= $j(internalHubMenuWrapHeight).offset().top - adminOffset) {
        internalHubMenuWrap.classList.add('is-sticky');
        internalHubMenuWrapHeight.classList.add('active');
        internalHubMenuWrap.classList.remove('menu-is-visible');
      } else {
        internalHubMenuWrap.classList.remove('is-sticky');
        internalHubMenuWrapHeight.classList.remove('active');
      }

      if (currentScrollPos < lastScroll) {
        internalHubMenuWrap.classList.add('menu-is-visible');
        if (scrollDelay) {
          clearTimeout(scrollDelay); //cancel the previous timer.
          scrollDelay = null;
        }
        scrollDelay = setTimeout(() => {
          if (window.pageYOffset !== 0) {
            internalHubMenuWrap.classList.remove('menu-is-visible');
          }
        }, 4000);
      }

      lastScroll = currentScrollPos;
    }

    function scrollGradientCheck() {
      if (internalHubMenu.querySelector('.link-active')) {
        if (internalHubMenu.querySelector('.link-active:first-child') && internalHubMenuScroll.maxScrollX !== 0) {
          internalHubMenuScroll.scrollToElement(internalHubMenu.querySelector('.link-active:first-child'), 200, -30, 0, IScroll.utils.ease.quadratic);
          setTimeout(() => {
            $j(internalHubMenu).closest('.internal-hub-nav__nav-desktop').removeClass('scroll-end--right');
            $j(internalHubMenu).closest('.internal-hub-nav__nav-desktop').addClass('scroll-end--left');
          }, 100);
        } else if (internalHubMenu.querySelector('.link-active:last-child') && internalHubMenuScroll.maxScrollX !== 0) {
          internalHubMenuScroll.scrollToElement(internalHubMenu.querySelector('.link-active:last-child'), 200, 30, 0, IScroll.utils.ease.quadratic);

          setTimeout(() => {
            $j(internalHubMenu).closest('.internal-hub-nav__nav-desktop').addClass('scroll-end--right');
            $j(internalHubMenu).closest('.internal-hub-nav__nav-desktop').removeClass('scroll-end--left');
          }, 100);
        } else {
          internalHubMenuScroll.scrollToElement(internalHubMenu.querySelector('.link-active'), 200, -40, 0, IScroll.utils.ease.quadratic);
        }
      }
    }

    function scrollSpy() {
      const linksList = window.outerWidth >= 768 ? $$('.internal-hub-nav__nav li a') : $$('.internal-hub-nav__nav-mobile option');
      const sections = [];

      linksList.forEach(link => {
        if ($(link.hash)) {
          sections.push($(link.hash));
        } else if (link.getAttribute('value')) {
          sections.push($(link.getAttribute('value')));
        }
      });

      window.onscroll = () => {
        if (window.outerWidth >= 768) {
          const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
          for (const s in sections) {
            if (sections.hasOwnProperty(s) && $j(sections[ s ]).offset().top - 100 <= scrollPos && isInViewport(sections[ s ])) {
              const id = sections[ s ].id;
              const linkActive = document.querySelector(`a[href*=${ id }]`);
              const currentActiveLink = document.querySelector('.internal-hub-nav__nav li.link-active');
              if (currentActiveLink) {
                currentActiveLink.classList.remove('link-active');
              }

              if (isInViewport(sections[ s ])) { //make sure the element is near the viewport if scrolling up to activate the link
                linkActive.parentNode.classList.add('link-active');
              } else {
                currentActiveLink.classList.remove('link-active');
              }
            }
          }
        } else {
          const scrollPos = window.pageYOffset;
          for (const s in sections) {
            if (sections.hasOwnProperty(s) && $j(sections[ s ]).offset().top - 140 <= scrollPos && isInViewport(sections[ s ])) {
              const id = sections[ s ].id;
              $('.internal-hub-nav__nav-mobile').value = `#${ id }`;
            }
          }
        }
      };
    }

    function mobileDropdown(e) {
      const mobileDropdownElem = e.target;

      // Figure out element to scroll to
      let target = $j(mobileDropdownElem.value);
      target = target.length ? target : $j('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        setTimeout(() => {
          scrollGradientCheck();
        }, 200);
        window.scrollTo({
          top: target.offset().top - 130,
        });
      }
    }

    if (window.outerWidth >= 768) {
      $('.js-internal-hub__scroll-left').classList.add('disabled');
      $('.js-internal-hub__scroll-left').setAttribute('disabled', true);
      window.addEventListener('scroll', handleOnScroll);
      setGradient(internalHubMenuScroll.x, internalHubMenuScroll.maxScrollX);
    } else {
      $('.internal-hub-nav__nav-mobile').addEventListener('change', mobileDropdown);
      $('.internal-hub-nav__nav-mobile').addEventListener('blur', mobileDropdown);
      window.addEventListener('scroll', handleOnScrollMobile);
    }

    scrollSpy();
  }
}

export default InternalHubMenu;
